import axios from "axios";


const apiQuestions = (fillVar) => {
    axios.get("https://nyu.danielwalt.io/api/questions")
        .then((resp) => {
            
            fillVar.value = resp.data;
        })
        .catch((err) => {
            console.log(err)
            fillVar.value = [{}];
        })
}

export {apiQuestions}